module.exports = __webpack_public_path__ + "img/002.b3b387fc.png";